import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    siteTheme: "",
    creditCardInfo: [],
    completeCreditCardNumber: "",
    transactionId: "",
    paymentSuccess: false,
    mobileNumber: "",
    payingAmount: "",
    paymentMethod: "",
    isCompName: "",
    stepperPage: "",
    savedCardExpDate: [],
    refNumber: "",
    callBackUrl: "",
    transactionCompleteTime: Number,
    nationalCodeNeeded: false,
    tetherCurrentPrice: "",
    vatanCurrentPrice: "",
    bitcoinCurrentPrice: "",
    perfectMoneyCurrentPrice: "",
    tronCurrentPrice: "",
    version: "",
    gatewayPendingFlag: true,
    globalApiRequestPending: true,
    receivedCreditCardFromServer: false,
    receivedPhoneNumberFromServer: false,
    receivedFixAmountFromServer: false,
    siteId: null,
    creditCardInfoIfCode6666: {
      cvv2: "",
      expireMonth: "",
      expireYear: "",
    },
    shetabSelectedPayingAmount: null,
    shaparakAmounts: null,
    shaparakCompleteCreditCardNumber: "",
    shaparakPayingAmount: "",
    shaparakCallBackUrl: "",
    shaparakTransactionRefNumber: "",
    savedSelectedCardSlide: null,
    sitesApiResult: {},
    mobileLayout: window.innerWidth < 990,
    smallDesktopMonitor: window.innerWidth < 1500,
    cryptoGroupActiveGateways: null,
    appLang: "fa",
    offlineCards: [],
    selectShaparakMethod: false,
  },
  getters: {
    getSiteTheme: (state) => {
      return state.siteTheme;
    },
    getSelectShaparakMethod: (state) => {
      return state.selectShaparakMethod;
    },
    getMobileLayout: (state) => {
      return state.mobileLayout;
    },
    getSmallDesktopMonitor: (state) => {
      return state.smallDesktopMonitor;
    },
    getCreditCardInfo: (state) => {
      return state.creditCardInfo;
    },
    getSitesApiResult: (state) => {
      return state.sitesApiResult;
    },
    getNationalCodeNeeded: (state) => {
      return state.nationalCodeNeeded;
    },
    getCompleteCreditCardNumber: (state) => {
      return state.completeCreditCardNumber;
    },
    getTransactionId: (state) => {
      return state.transactionId;
    },
    getPaymentSuccess: (state) => {
      return state.paymentSuccess;
    },
    getMobileNumber: (state) => {
      return state.mobileNumber;
    },
    getPayingAmount: (state) => {
      return state.payingAmount;
    },
    getPaymentMethod: (state) => {
      return state.paymentMethod;
    },
    getIsCompName: (state) => {
      return state.isCompName;
    },
    getStepperPage: (state) => {
      return state.stepperPage;
    },
    getSavedCardExpDate: (state) => {
      return state.savedCardExpDate;
    },
    getRefNumber: (state) => {
      return state.refNumber;
    },
    getCallBackUrl: (state) => {
      return state.callBackUrl;
    },
    getTransactionCompleteTime: (state) => {
      return state.transactionCompleteTime;
    },
    getTetherCurrentPrice: (state) => {
      return state.tetherCurrentPrice;
    },
    getVatanCurrentPrice: (state) => {
      return state.vatanCurrentPrice;
    },
    getBitcoinCurrentPrice: (state) => {
      return state.bitcoinCurrentPrice;
    },
    getPerfectMoneyCurrentPrice: (state) => {
      return state.perfectMoneyCurrentPrice;
    },
    getVersion: (state) => {
      return state.version;
    },
    getGatewayPendingFlag: (state) => {
      return state.gatewayPendingFlag;
    },
    getGlobalApiRequestPending: (state) => {
      return state.globalApiRequestPending;
    },
    getTronCurrentPrice: (state) => {
      return state.tronCurrentPrice;
    },
    isCreditCardReceivedFromServer: (state) => {
      return state.receivedCreditCardFromServer;
    },
    isPhoneNumberReceivedFromServer: (state) => {
      return state.receivedPhoneNumberFromServer;
    },
    isShetabAmountsReceivedFromServer: (state) => {
      return state.receivedFixAmountFromServer;
    },
    getCreditCardInfoIfCode6666: (state) => {
      return state.creditCardInfoIfCode6666;
    },
    getSiteId: (state) => {
      return state.siteId;
    },
    getShaparakAmounts: (state) => {
      return state.shaparakAmounts;
    },
    getShaparakCompleteCreditCardNumber: (state) => {
      return state.shaparakCompleteCreditCardNumber;
    },
    getShaparakPayingAmount: (state) => {
      return state.shaparakPayingAmount;
    },
    getShaparakCallBackUrl: (state) => {
      return state.shaparakCallBackUrl;
    },
    getShaparakTransactionRefNumber: (state) => {
      return state.shaparakTransactionRefNumber;
    },
    getShetabSelectedPayingAmount: (state) => {
      return state.shetabSelectedPayingAmount;
    },
    getSavedSelectedCardSlide: (state) => {
      return state.savedSelectedCardSlide;
    },
    getCryptoGroupActiveGateways: (state) => {
      return state.cryptoGroupActiveGateways;
    },
    getAppLang: (state) => {
      return state.appLang;
    },
    getOfflineCards: (state) => {
      return state.offlineCards;
    },
  },
  mutations: {
    setSiteTheme: (state, payload) => {
      state.siteTheme = payload;
    },
    setSelectShaparakMethod: (state, payload) => {
      state.selectShaparakMethod = payload;
    },

    setCreditCardInfo: (state, payload) => {
      state.creditCardInfo = payload;
    },
    setSitesApiResult: (state, payload) => {
      state.sitesApiResult = payload;
    },
    setNationalCodeNeeded: (state, payload) => {
      state.nationalCodeNeeded = payload;
    },
    setCompleteCreditCardNumber: (state, payload) => {
      state.completeCreditCardNumber = payload;
    },
    setTransactionId: (state, payload) => {
      state.transactionId = payload;
    },
    setPaymentSuccess: (state, payload) => {
      state.paymentSuccess = payload;
    },
    setMobileNumber: (state, payload) => {
      state.mobileNumber = payload;
    },
    setPayingAmount: (state, payload) => {
      state.payingAmount = payload;
    },
    setPaymentMethod: (state, payload) => {
      state.paymentMethod = payload;
    },
    setIsCompName: (state, payload) => {
      state.isCompName = payload;
    },
    setStepperPage: (state, payload) => {
      state.stepperPage = payload;
    },
    setSavedCardExpDate: (state, payload) => {
      state.savedCardExpDate = payload;
    },
    setRefNumber: (state, payload) => {
      state.refNumber = payload;
    },
    setCallBackUrl: (state, payload) => {
      state.callBackUrl = payload;
    },
    setTransactionCompleteTime: (state, payload) => {
      state.transactionCompleteTime = payload;
    },
    setTetherCurrentPrice: (state, payload) => {
      state.tetherCurrentPrice = payload;
    },
    setVatanCurrentPrice: (state, payload) => {
      state.vatanCurrentPrice = Math.floor(payload);
    },
    setBitcoinCurrentPrice: (state, payload) => {
      state.bitcoinCurrentPrice = Math.floor(payload);
    },
    setPerfectMoneyCurrentPrice: (state, payload) => {
      state.perfectMoneyCurrentPrice = payload;
    },
    setTronCurrentPrice: (state, payload) => {
      state.tronCurrentPrice = payload;
    },
    setVersion: (state, payload) => {
      state.version = payload;
    },
    setGatewayPendingFlag: (state, payload) => {
      state.gatewayPendingFlag = payload;
    },
    setGlobalApiRequestPending: (state, payload) => {
      state.globalApiRequestPending = payload;
    },

    setCreditCardReceivedFromServerCondition: (state, payload) => {
      state.receivedCreditCardFromServer = payload;
    },
    setPhoneNumberReceivedFromServerCondition: (state, payload) => {
      state.receivedPhoneNumberFromServer = payload;
    },
    setShetabAmountsReceivedFromServerCondition: (state, payload) => {
      state.receivedFixAmountFromServer = payload;
    },
    setCreditCardInfoIfCode6666: (state, payload) => {
      state.creditCardInfoIfCode6666 = payload;
    },
    setSiteId: (state, payload) => {
      state.siteId = payload;
    },
    setShaparakAmounts: (state, payload) => {
      state.shaparakAmounts = payload;
    },
    setShaparakCompleteCreditCardNumber: (state, payload) => {
      state.shaparakCompleteCreditCardNumber = payload;
    },
    setShaparakPayingAmount: (state, payload) => {
      state.shaparakPayingAmount = payload;
    },
    setShaparakCallBackUrl: (state, payload) => {
      state.shaparakCallBackUrl = payload;
    },
    setShaparakTransactionRefNumber: (state, payload) => {
      state.shaparakTransactionRefNumber = payload;
    },
    setShetabSelectedPayingAmount: (state, payload) => {
      state.shetabSelectedPayingAmount = payload;
    },
    setSavedSelectedCardSlide: (state, payload) => {
      state.savedSelectedCardSlide = payload;
    },
    setMobileLayout: (state, payload) => {
      state.mobileLayout = payload;
    },

    setSmallDesktopMonitor: (state, payload) => {
      state.smallDesktopMonitor = payload;
    },
    setCryptoGroupActiveGateways: (state, payload) => {
      state.cryptoGroupActiveGateways = payload;
    },

    setAppLang: (state, payload) => {
      state.appLang = payload;
    },
    setOfflineCards: (state, payload) => {
      state.offlineCards = payload;
    },
  },
});
